export default __webpack_public_path__ + "static/media/just-nosh-berlin.101447b3.png";